import React from 'react';
import { Text } from 'library';
import { Grid } from '@material-ui/core';
import { UserPostModel } from '../../NewsfeedModels';
import UserProfilePicture from '../../UserProfilePicture';

interface IProps {
    user: UserPostModel;
}

export default function UserInfo({ user }: IProps) {
    function titleCase(string: string) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
    }

    return (
        <Grid container item>
            <UserProfilePicture profileImage={user.profile_picture.image} size="sm" />
            <Grid item>
                <Grid container direction="column">
                    <Text variant="body2" bold>
                        {user.first_name} {user.last_name_initial}
                    </Text>
                    <Text variant="body3" bold>
                        {titleCase(user.role)}
                    </Text>
                </Grid>
            </Grid>
        </Grid>
    );
}
